import { ExtranetOrderDto, ExtranetOrderListItemDto } from '@pharmac-extranet/extranet-api'
import {
  ExtranetContainer,
  ExtranetExpandArrowColumn,
  ExtranetTable,
  ExtranetTableColumn,
  ExtranetTableRow,
  useBreakpoint,
  useLanguage,
} from '@pharmac-extranet/shared'
import { OrderHistoryCustomerGroupOrder } from './OrderHistoryCustomerGroupOrder'
import { useOrderCheckboxes } from './useOrderCheckboxes'

type OrderHistoryCustomerTableProps = {
  tableItem: ExtranetOrderListItemDto
  hook: ReturnType<typeof useOrderCheckboxes>
}

export const OrderHistoryCustomerGroupOrders = ({
  tableItem,
  hook,
}: OrderHistoryCustomerTableProps) => {
  const { minDesktop } = useBreakpoint()
  const { t } = useLanguage(['extranet'])
  const checkboxes = hook.checkboxes[tableItem.groupId + tableItem.createdAt]

  const isChecked = ({ id }: ExtranetOrderDto) => {
    return !!checkboxes?.find((checked) => id === checked)
  }

  const sortOrder = (a: ExtranetOrderDto, b: ExtranetOrderDto) => {
    const collator = new Intl.Collator(['fi', 'sv'], { numeric: true, sensitivity: 'base' })
    const nameDiff = collator.compare(a.wholeName, b.wholeName)

    if (nameDiff !== 0) return nameDiff

    if (a.endDate > b.endDate) return -1
    if (b.endDate > a.endDate) return 1

    return 0
  }

  const sortedOrders = tableItem.orders.sort(sortOrder)

  return (
    <ExtranetContainer full>
      <ExtranetTable style={{ fontFamily: 'var(--font-family-secondary)', fontWeight: 300 }}>
        {minDesktop && (
          <ExtranetTableRow
            noBorders
            noMargin
            style={{
              backgroundColor: 'var(--extranet-light-purple)',
              border: 'none',
              fontWeight: 400,
            }}
          >
            <ExtranetTableColumn size={0.5} />
            <ExtranetTableColumn size={2}>{t('orderHistory.name')}</ExtranetTableColumn>
            <ExtranetTableColumn size={1}>{t('orderHistory.dateOfBirth')}</ExtranetTableColumn>
            <ExtranetTableColumn size={1.5}>
              {t('orderHistory.subscriptionPeriod')}
            </ExtranetTableColumn>
            <ExtranetTableColumn>{t('orderHistory.orderNumber')}</ExtranetTableColumn>
            <ExtranetTableColumn>{t('orderHistory.comments')}</ExtranetTableColumn>
            <ExtranetTableColumn>{t('orderHistory.orderState')}</ExtranetTableColumn>
            <ExtranetTableColumn>{t('orderHistory.deliveryDate')}</ExtranetTableColumn>
            <ExtranetExpandArrowColumn />
          </ExtranetTableRow>
        )}
        {sortedOrders.map((a) => (
          <OrderHistoryCustomerGroupOrder
            key={a.id}
            checked={isChecked(a)}
            handleOrderCheckChange={() => hook.toggleOrderCheckbox(tableItem, a.id)}
            item={a}
          />
        ))}
      </ExtranetTable>
    </ExtranetContainer>
  )
}
